// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0d689e2d","491":"58f39465"}[chunkId] + ".chunk.js";
};